export default __webpack_public_path__ + "static/media/95_mobile.47562415.jpg";